import * as React from "react";
import * as cn from "classnames";
const styles = require("./style.less");

export default class WarningIcon extends React.Component {
    render() {
        return <em className={cn("fa fa-warning", styles.warningIcon)} />;
    }
}
